export enum ItemTypes {
    sku = 'sku',
    product = 'product'
}
